// extracted by mini-css-extract-plugin
export var orderSummary = "_pu-0";
export var showMoreLessButton = "_pu-1";